<template>
  <div
    v-if="show_integration_indicator"
    class="flex cursor-pointer items-center justify-center"
    @click.stop
  >
    <div
      v-if="is_ziggu_api_url"
      v-tooltip="integration_name(integration_id)"
    >
      <a @click="fetchIntegrationUrl">
        <i :class="integration_icon_class(integration_id)" />
      </a>
    </div>
    <div
      v-else
      v-tooltip="integration_name(integration_id)"
    >
      <a
        :href="integration_url(record)"
        target="_blank"
      >
        <i :class="integration_icon_class(integration_id)" />
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { PROFILE_TYPES, RECORD_TYPE } from '@/app/data/model_constants';
import { ZIGGU_API_URL } from '@/app/util/urls';

const SHOW_INTEGRATION_INDICATOR_FOR = [
  RECORD_TYPE.CUSTOMER,
  RECORD_TYPE.DOCUMENT,
  RECORD_TYPE.DECISION,
  RECORD_TYPE.PROPOSAL,
  RECORD_TYPE.SPACE,
  RECORD_TYPE.UNIT,
  RECORD_TYPE.INSTALLMENT,
];

export default {
  name: 'IntegrationIndicator',
  props: {
    record: { type: Object, required: true },
  },

  data() {
    return {
      ziggu_api_base_url: ZIGGU_API_URL,
    };
  },

  computed: {
    ...mapGetters([
      'current_profile',
      'integration_icon_class',
      'integration_name',
      'integration_url',
      'integration_url_template',
    ]),

    integration_id() {
      return this.record.attributes.integration_id;
    },

    is_ziggu_api_url() {
      return _.includes(this.integration_url_template(this.integration_id), '://api.ziggu.');
    },

    show_integration_indicator() {
      return (
        this.current_profile.type === PROFILE_TYPES.EMPLOYEE &&
        this.integration_id &&
        SHOW_INTEGRATION_INDICATOR_FOR.includes(this.record.type)
      );
    },
  },

  methods: {
    ...mapActions(['FETCH_INTEGRATION_URL']),

    async fetchIntegrationUrl() {
      if (this.record.attributes.integration_url) {
        window.open(this.record.attributes.integration_url, '_blank');
      } else {
        const json = await this.FETCH_INTEGRATION_URL({ record_type: this.record.type, record_id: this.record.id });
        const json_string = JSON.stringify(json, null, 2);
        const win = await window.open(
          '',
          '',
          'toolbar=no,location=no§,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=780,height=780',
        );
        win.document.body.innerHTML = `<pre>${json_string}</pre>`;
      }
    },
  },
};
</script>
